import { Params, ParamMap } from '@angular/router';
import { JobListArgsQuoteStatus } from 'src/shared/api';

export const QUOTE_STATUSES_KEY = 'qs';

export const toQuoteStatusParams = (args: {
	quoteStatus?: JobListArgsQuoteStatus;
}): Params => ({
	[QUOTE_STATUSES_KEY]: args.quoteStatus ? args.quoteStatus : undefined,
});

export const toQuoteStatusListArgs = (
	paramMap: ParamMap
): { quoteStatus?: JobListArgsQuoteStatus } =>
	paramMap.has(QUOTE_STATUSES_KEY)
		? {
				quoteStatus: paramMap.get(
					QUOTE_STATUSES_KEY
				) as JobListArgsQuoteStatus,
		  }
		: undefined;
